// An answer can cross the turn's finalization boundary while the card's
// callback still holds the previous render's "active" state. The host knows
// whether it delivered a live steer or needs a fresh turn.
export function workQuestionAnswerMeta(response, skipped = false) {
  return {
    skipped,
    ...(typeof response?.requiresResume === 'boolean' ? { requiresResume: response.requiresResume } : {}),
  };
}

export function workQuestionContinuation(text, { isActive, requiresResume, skipped } = {}) {
  if (requiresResume === false || (requiresResume !== true && isActive)) return null;
  return String(text || '').trim()
    || (skipped ? 'Skip — pick a sensible default and keep going.' : null);
}
